export type TokenType = {
  chainId: number;
  name: string;
  symbol: string;
  decimals: number;
  logoURI: string;
  address: string;
  native?: boolean;
};

export enum TypeOfSwap {
  swapExactTokensForTokens = 'swapExactTokensForTokens',
  swapTokensForExactTokens = 'swapTokensForExactTokens',
}

export type TxHistory = {
  txhash: string;
  type: 'normal' | 'encrypted' | 'decrypted';
  from: string;
  to: string;
  amount: number;
  date: string;
};

export enum Direction {
  default = 'default',
  reverted = 'reverted',
}
